// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_eb-a";
export var fulfillmentFormRail = "_eb-9";
export var headerTitleRow = "_eb-c";
export var orderDetailsWrapper = "_eb-7";
export var orderLinkTrigger = "_eb-2";
export var paymentInformationGrid = "_eb-h";
export var paymentSummaryColumn = "_eb-i";
export var shipmentContainer = "_eb-b";
export var shipmentDetailsMainPane = "_eb-8";
export var shipmentNavigationCard = "_eb-5";
export var shipmentNavigationRail = "_eb-3";
export var shipmentNavigationRailHeader = "_eb-4";
export var shipmentSummaryFact = "_eb-e";
export var shipmentSummaryGrid = "_eb-d";
export var shipmentSummaryMetadataRow = "_eb-f";
export var shipmentSummaryTags = "_eb-g";
export var shipmentWorkspace = "_eb-0";
export var shipmentWorkspaceContent = "_eb-6";
export var shipmentWorkspaceHeader = "_eb-1";